module.exports = __webpack_public_path__ + "static/media/soft.716e0b75.png";